import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { fetch } from '@nx/angular';
import { map } from 'rxjs/operators';

import { Store } from '@ngrx/store';
import * as ShipmentRelationActions from './shipment-relations.actions';
import { ShipmentRelationsServiceBase } from '../shipment-relations-service-base';

@Injectable()
export class ShipmentRelationsEffects {
    init$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ShipmentRelationActions.init),
            fetch({
                run: action => {
                    return this.service
                        .getShipmentQuotation(action.shipmentId)
                        .pipe(
                            map(quotation =>
                                ShipmentRelationActions.loadShipmentQuotationSuccess(
                                    {
                                        quotation,
                                    }
                                )
                            )
                        );
                },
                onError: (action, error) => {
                    console.error(error);
                    return ShipmentRelationActions.loadShipmentQuotationFailure(
                        { error }
                    );
                },
            })
        )
    );

    constructor(
        private actions$: Actions,
        private service: ShipmentRelationsServiceBase,
        private store: Store
    ) {}
}
